import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';

import { AlertService, StudentService, AuthenticationService } from '../_services';
import { Globals } from '../_helpers';

import { Subject } from 'rxjs';
import { Observable, throwError } from 'rxjs';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';


@Component({
    selector: 'app-home',
    templateUrl: './student-list.component.html'
})

export class StudentlistComponent implements OnInit {
    
    @ViewChild('overSwal') private overSwal: SwalComponent;
    @ViewChild('theorynotdone') private theorynotdone: SwalComponent;

    public alertOption: SweetAlertOptions = {};

    loading = false;
    isError = false;
    submitted = false;
    errorMsg: string;
    returnUrl: string;
    students = [];
    activeExam = {};
    localData = {};
    studentdp: string = '/assets/images/pic-upload.png';
    student_id: void;
    viva_assessor: number
    viva_pc: number = 0;
    practical_viva: number = 0;
    allowExamType: number = 0;
    examid:number = 0;
    viva = false
    viva2: any;
    vivapc = false
    over3
    over2

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private studentService: StudentService,
        private alertService: AlertService,
        private globals: Globals,
    ) { }
    
    ngOnInit() {
        this.localData = JSON.parse(localStorage.getItem('currentUser'));
        this.activeExam = JSON.parse(localStorage.getItem('activeExam_PS'));
        // this.imagePath = '/assets/images/pic-upload.png';
        this.over2 = '/assets/images/marks_update.png';
        this.over3 = '/assets/images/is_over=2.png';

        this.allowExamType = parseInt(this.route.snapshot.paramMap.get("step"));
        //console.log(this.allowExamType);
        // get return url from route parameters or default to '/'
        this.returnUrl = '/';

        /* Call on load function */
        this.viva_assessor = this.activeExam['viva_assessor'];
        this.viva_pc = this.activeExam['vivapc'];
        this.practical_viva = this.activeExam['viva_practical'];
        this.examid = this.activeExam['exam_id'];
        //console.log(this.allowExamType +'----'+ this.viva_pc);
        if (this.viva_assessor == 1 && this.allowExamType == 1) { // 1 viva by assessor
            this.viva = true;
            this.getStudentList();
        } else if(this.allowExamType == 3 && this.viva_pc == 1){ // 3 viva pc
            this.getvivapcStudentList();
        } else if(this.allowExamType == 2 && this.practical_viva == 1){ // 2 viva2 practical
            this.getPracticalStudentList();
        }
    }

    /* get all student for viva exam under this assessor */
    private getStudentList() {
        this.submitted = true;
        this.studentService.getStudents(this.globals.root_url, this.localData['usercode'], this.localData['id'], this.examid)
            .pipe(first())
            .subscribe(
                data => {
                    //console.log(data);
                    if (data.code == 1000) {
                        this.students = data.students;
                    }
                    else if (data.code == 1002) {
                        this.isError = true;
                        // this.router.navigateByUrl('/viva-list')
                        this.errorMsg = 'You do not have any viva/practical. !!';
                    }
                    else if (data.status == 'COM_TOKEN_ERROR') {
                        this.loading = false;
                        this.router.navigateByUrl('/login');
                    }
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                }
            );
    }
    private getvivapcStudentList() {
        //this.viva = true;
        this.studentService.matrixAssessStudentlist(this.globals.root_url, this.localData['usercode'], this.localData['id'], this.examid)
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        this.students = data.students;
                    }
                    else if (data.code == 1002) {
                        this.isError = true;
                        this.errorMsg = 'You do not have any MatrixAssess. !!';
                    }
                    else if (data.status == 'COM_TOKEN_ERROR') {
                        this.loading = false;
                        this.router.navigateByUrl('/login');
                    }
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                }
            );
    }

    private getPracticalStudentList() {
        this.studentService.practicalStudentlist(this.globals.root_url, this.localData['usercode'], this.localData['id'], this.examid)
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        this.students = data.students;
                    }
                    else if (data.code == 1002) {
                        this.isError = true;
                        this.errorMsg = 'You do not have any Practical. !!';
                    }
                    else if (data.status == 'COM_TOKEN_ERROR') {
                        this.loading = false;
                        this.router.navigateByUrl('/login');
                    }
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                }
            );
    }

    /* switch exam instruction for assessor */
    public startViva(student_id, viva_first, viva_assessor, vivadone) {
        //console.log(viva_assessor+'--'+ viva_first+'--'+ vivadone);
        if(viva_first == 0 && viva_assessor == 1)
        {
            if(vivadone == 1)
            {
                this.viva2 = '&v1';
                this.globals.studentId = student_id;
                this.router.navigateByUrl('/test-start/' + student_id +'/'+ btoa(this.viva2));
            }
            else
            {
                this.theorynotdone.show();
            }
        }
        else if(viva_first == 1 && viva_assessor == 1)
        {
            if(vivadone == 0)
            {
                this.viva2 = '&v1';
                this.globals.studentId = student_id;
                this.router.navigateByUrl('/test-start/' + student_id +'/'+ btoa(this.viva2));
            }
            else
            {
                this.theorynotdone.show();
            }           
        }

    }
    public startViva2(student_id) {
        this.viva2 = '&v2';
        this.router.navigateByUrl('/test-start/' + student_id +'/'+ btoa(this.viva2));
    }   
    public startPC(student_id) {
        this.viva2 = '&pc';
        this.router.navigateByUrl('/test-start/' + student_id +'/'+ btoa(this.viva2));
    }      
    public over(vc: number) {
        if (vc == 2) {
            this.overSwal.show();
            return;
        }
    }

    public marksupdate(id: Number) {
        this.router.navigateByUrl('/viva-marks/' + id);
    }

    public gotoDashboard() {
       this.router.navigateByUrl('/home/' + this.examid+'/'+this.viva_assessor+'/'+this.viva_pc+'/'+this.practical_viva);
    }

    public reload() {
        window.location.reload();
    }

   

}
